<div class="inner-content">
  <p class="SCWEB-header-text">Your receipt</p>
  <div id="receipt-wrapper" *ngIf="cost">

    <event-receipt [costs]="cost" [serviceTitle]="serviceTitle" [cancelled]="false">
    </event-receipt>

  </div>
</div>